import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { env } from "@/lib/env";
import "@/styles/app.css";

async function startMocks(): Promise<void> {
  if (!env.useMocks) return;
  try {
    const { worker } = await import("@/mocks/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
  } catch (error) {
    // Service workers can be unavailable (embedded browsers, some private modes).
    // Render anyway so the failure is visible in the UI instead of a blank page.
    console.warn("[mocks] Could not start the MSW worker; calls will hit the real API.", error);
  }
}

async function bootstrap(): Promise<void> {
  await startMocks();

  // Imported after the worker is live: creating the router kicks off the first loaders.
  const { App } = await import("./App");

  const container = document.getElementById("root");
  if (!container) throw new Error("Missing #root element");

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
